"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CookieConsentComponent = /*#__PURE__*/function () {
  function CookieConsentComponent() {
    _classCallCheck(this, CookieConsentComponent);
    var _this = this;
    this.cookieC = initCookieConsent();
    this.expiration = 180; //in days;
    this.cookieC.run({
      current_lang: locale,
      autoclear_cookies: true,
      // default: false
      page_scripts: true,
      // default: false
      level: ["necessary", "analytics", "marketing"],
      onFirstAction: function onFirstAction(cookie) {
        cookie.action = "first_action";
        cookie.expiration = _this.expiration;
        $.ajax({
          url: cookieUpdateSessionExpiration,
          method: "POST",
          data: cookie
        });
      },
      onAccept: function onAccept(cookie) {
        gtag('consent', 'update', {
          ad_storage: cookie.level.includes("analytics") || cookie.level.includes("marketing") ? "granted" : "denied",
          analytics_storage: cookie.level.includes("analytics") ? "granted" : "denied",
          personalization_storage: cookie.level.includes("marketing") ? "granted" : "denied"
        });
      },
      onChange: function onChange(cookie, changed_categories) {
        if (!cookie.level.includes("marketing")) {
          _this.delete_cookie("affiliateid");
          _this.delete_cookie("affiliate");
        }
        cookie.action = "update";
        cookie.expiration = _this.expiration;
        $.ajax({
          url: cookieUpdateSessionExpiration,
          method: "POST",
          data: cookie
        });
        console.log("y");
        if (!cookie.level.includes("analytics")) {
          console.log("x");
          var gaCookies = ["_ga", "_gcl_au", "_gid"];
          var _loop = function _loop() {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              value = _Object$entries$_i[1];
            gaCookies.forEach(function (currentValue) {
              if (key.includes(currentValue)) {
                console.log("todelete");
                console.log(key);
                _this.delete_cookie(key);
              }
            });
          };
          for (var _i = 0, _Object$entries = Object.entries(_this.getCookies()); _i < _Object$entries.length; _i++) {
            _loop();
          }
        }
        gtag('consent', 'update', {
          ad_storage: cookie.level.includes("analytics") ? "granted" : "denied",
          analytics_storage: cookie.level.includes("analytics") ? "granted" : "denied",
          personalization_storage: cookie.level.includes("marketing") ? "granted" : "denied"
        });
      },
      gui_options: {
        consent_modal: {
          layout: 'bar',
          // box/cloud/bar
          position: 'bottom center',
          // bottom/middle/top + left/right/center
          transition: 'slide',
          // zoom/slide
          swap_buttons: false // enable to invert buttons
        },
        settings_modal: {
          layout: 'box',
          // box/bar
          position: 'right',
          // left/right
          transition: 'slide' // zoom/slide
        }
      },
      languages: _this.defineTranslate()
    });
  }
  _createClass(CookieConsentComponent, [{
    key: "delete_cookie",
    value: function delete_cookie(name) {
      document.cookie = name + '=; Max-Age=0; path=/; domain=' + location.host;
    }
  }, {
    key: "getCookies",
    value: function getCookies() {
      var pairs = document.cookie.split(";");
      var cookies = {};
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split("=");
        cookies[(pair[0] + '').trim()] = unescape(pair.slice(1).join('='));
      }
      return cookies;
    }
  }, {
    key: "defineTranslate",
    value: function defineTranslate() {
      var translates = {
        cs: {
          consent_modal: {
            title: 'Používáme cookies',
            description: 'Používáme <a href="' + privacyPolicyLink + '">cookies</a> za účelem správného fungování webu a k marketingovým účelům. Pokud souhlasíte, klepněte na "přijmout". Nebo se podívejte na podrobné nastavení a přizpůsobte si  <a href="javascript:void(0);" data-cc="c-settings">cookies</a> svým potřebám.<br><br> <button type="button"  class="button" data-cc="accept-all">Přijmout</button>  <button type="button"   class="button" data-cc="accept-necessary">Odmítnout volitelné</button> <button   class="button" type="button" data-cc="c-settings">Podrobné nastavení...</button>'
          },
          settings_modal: {
            title: 'Nastavení cookies',
            save_settings_btn: 'Uložit volby',
            accept_all_btn: 'Přijmout vše',
            reject_all_btn: 'Odmítnout všechny volitelné',
            close_btn_label: 'Zavřít',
            cookie_table_headers: [{
              col1: 'Cookie'
            }, {
              col2: 'Doména'
            }, {
              col3: 'Expirace'
            }, {
              col4: 'Popis'
            }, {
              col5: 'Zpracovatel'
            }],
            blocks: [{
              title: 'Používáme Cookies',
              description: 'Soubory cookie používáme k analýze údajů o našich návštěvnících, ke zlepšení našich webových stránek, zobrazení personalizovaného obsahu a k tomu, abychom vám poskytli skvělý zážitek z webu.'
            }, {
              title: 'Funkční cookies',
              description: 'Tato stránka obsahuje soubory cookie, které jsou nezbytné pro fungování našich webových stránek. Podílejí se na funkcích, jako jsou jazykové preference, distribuce provozu nebo udržování uživatelské relace. Nelze je zakázat.',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true // cookie categories with readonly=true are all treated as "necessary cookies"
              },
              cookie_table: [
              // list of all expected cookies
              {
                col1: 'cc_cookie',
                // match all cookies starting with "_ga"
                col2: '24usoftware.com',
                col3: '182 dní',
                col4: 'Ukládá souhlas/nesouhlas uživatele s používáním cookies.',
                col5: '24U s.r.o.'
              }, {
                col1: 'PHPSESSID',
                col2: '24usoftware.com',
                col3: 'Relace',
                col4: 'Ukládá informace o uživatelově relaci.',
                col5: '24U s.r.o.'
              }, {
                col1: '_nss',
                col2: '24usoftware.com',
                col3: 'Relace',
                col4: 'Součást programovacího frameworku, který zajišťuje vyšší bezpečnost webové aplikace.',
                col5: '24U s.r.o.'
              }, {
                col1: 'first_visit_time_cookie',
                col2: '24usoftware.com',
                col3: '1 rok',
                col4: 'Ukládá čas, kdy uživatel navštívil webovou stránku (slouží jako část antispamové ochrany pro odesílání formulářů). Ukládá se pouze čas příchodu na stránku.',
                col5: '24U s.r.o.'
              }]
            }, {
              title: 'Analytická cookies',
              description: 'Používáme nástroje, které nám umožňují analyzovat používání naší stránky. Tyto údaje nám umožňují zlepšit uživatelské rozhraní naší webové služby.',
              toggle: {
                value: 'analytics',
                // your cookie category
                enabled: true,
                readonly: false
              },
              cookie_table: [
              // list of all expected cookies
              {
                col1: '^_ga',
                // match all cookies starting with "_ga"
                col2: '24usoftware.com',
                col3: '2 year',
                col4: "Cookie je součástí Google Analytics, které využíváme k anonymnímu měření statistik a představě o chování uživatelů. Data získaná z Google Analytics nám pomáhají webové stránky efektivně vylepšovat.",
                col5: 'Alphabet Inc.',
                is_regex: true
              }, {
                col1: '_ga',
                // match all cookies starting with "_ga"
                col2: '24usoftware.com',
                col3: '2 year',
                col4: "Cookie je součástí Google Analytics, které využíváme k anonymnímu měření statistik a představě o chování uživatelů. Data získaná z Google Analytics nám pomáhají webové stránky efektivně vylepšovat.",
                col5: 'Alphabet Inc.'
              }, {
                col1: '_gid',
                col2: '24usoftware.com',
                col3: '1 day',
                col4: "Cookie je součástí Google Analytics, které využíváme k anonymnímu měření statistik a představě o chování uživatelů. Data získaná z Google Analytics nám pomáhají webové stránky efektivně vylepšovat.",
                col5: 'Alphabet Inc.'
              }, {
                col1: '^_gat_gtag_UA',
                col2: '24usoftware.com',
                col3: '1 minute',
                col4: "Cookie je součástí Google Analytics, které využíváme k anonymnímu měření statistik a představě o chování uživatelů. Data získaná z Google Analytics nám pomáhají webové stránky efektivně vylepšovat.",
                col5: 'Alphabet Inc.',
                is_regex: true
              }]
            }, {
              title: 'Marketing cookies',
              description: 'Tato skupina souborů cookis se používá k zobrazování reklam na témata, která Vás zajímají. Umožňuje také sledovat naše marketingové aktivity a pomáhá měřit výkon reklam.',
              toggle: {
                value: 'marketing',
                enabled: false,
                readonly: false
              },
              cookie_table: [
              // list of all expected cookies
              {
                col1: 'affiliate',
                // match all cookies starting with "_ga"
                col2: '24usoftware.com',
                col3: '24 hodin',
                col4: 'Cookie je součástí našeho Affiliate trackingu. Slouží pro vyhodnocení nároků na provize našim partnerům.',
                col5: '24U s.r.o.'
              }, {
                col1: 'affiliateid',
                // match all cookies starting with "_ga"
                col2: '24usoftware.com',
                col3: '24 hodin',
                col4: 'Cookie je součástí našeho Affiliate trackingu. Slouží pro vyhodnocení nároků na provize našim partnerům.',
                col5: '24U s.r.o.'
              }]
            }]
          }
        },
        en: {
          consent_modal: {
            title: 'We use cookies',
            description: 'We use <a href="' + privacyPolicyLink + '">cookies</a> to ensure that we give you best browsing experience on our website, and also for certain marketing purposes. Click on “accept” if you wish to allow all <a href="' + privacyPolicyLink + '">cookies</a>. Or customize your settings in the <a  href="javascript:void(0);" data-cc="c-settings">detailed settings</a>. <br><br> <button type="button"  class="button" data-cc="accept-all">Accept</button>  <button type="button"   class="button" data-cc="accept-necessary">Reject optional</button> <button   class="button" type="button" data-cc="c-settings">Detailed settings...</button>'
          },
          settings_modal: {
            title: 'Cookies settings',
            save_settings_btn: 'Save settings',
            accept_all_btn: 'Accept all',
            reject_all_btn: 'Reject all optional',
            close_btn_label: 'Close',
            cookie_table_headers: [{
              col1: 'Cookie'
            }, {
              col2: 'Domain'
            }, {
              col3: 'Expiration'
            }, {
              col4: 'Description'
            }, {
              col5: 'Owner'
            }],
            blocks: [{
              title: 'We use Cookies',
              description: 'We use cookies to analyse data about our visitors, to improve our website, to display personalised content and to give you a great web experience.'
            }, {
              title: 'Functional cookies',
              description: 'This group contains cookies that are necessary for our websites to work. They take part in functionalities like language preferences, traffic distribution or keeping user session. They cannot be disabled.',
              toggle: {
                value: 'necessary',
                enabled: true,
                readonly: true // cookie categories with readonly=true are all treated as "necessary cookies"
              },
              cookie_table: [
              // list of all expected cookies
              {
                col1: 'first_visit_time_cookie',
                // match all cookies starting with "_ga"
                col2: '24usoftware.com',
                col3: '1 year',
                col4: "It saves the time when a user visited a web page (serves as part of anti-spam protection for form submissions). Only the time of arrival to the page is saved.",
                col5: '24U s.r.o.'
              }, {
                col1: 'cc_cookie',
                // match all cookies starting with "_ga"
                col2: '24usoftware.com',
                col3: '182 days',
                col4: "It saves the user's approval/disapproval of the use of cookies.",
                col5: '24U s.r.o.'
              }, {
                col1: 'PHPSESSID',
                col2: '24usoftware.com',
                col3: 'Session',
                col4: "It saves information about the user's session.",
                col5: '24U s.r.o.'
              }, {
                col1: '_nss',
                col2: '24usoftware.com',
                col3: 'Session',
                col4: 'The part of a programming framework that makes web application more secure.',
                col5: '24U s.r.o.'
              }]
            }, {
              title: 'Analytical cookies',
              description: 'We use tools that let us analyze the usage of our page. Such data lets us improve the user experience of our web service.',
              toggle: {
                value: 'analytics',
                // your cookie category
                enabled: true,
                readonly: false
              },
              cookie_table: [
              // list of all expected cookies
              {
                col1: '^_ga',
                // match all cookies starting with "_ga"
                col2: '24usoftware.com',
                col3: '2 year',
                col4: "The cookie is part of Google Analytics, which we use to anonymously measure statistics and to understand user behaviour. The data obtained from Google Analytics helps us to improve the website effectively.",
                col5: 'Alphabet Inc.',
                is_regex: true
              }, {
                col1: '_ga',
                // match all cookies starting with "_ga"
                col2: '24usoftware.com',
                col3: '2 year',
                col4: "The cookie is part of Google Analytics, which we use to anonymously measure statistics and to understand user behaviour. The data obtained from Google Analytics helps us to improve the website effectively.",
                col5: 'Alphabet Inc.'
              }, {
                col1: '_gid',
                col2: '24usoftware.com',
                col3: '1 day',
                col4: "The cookie is part of Google Analytics, which we use to anonymously measure statistics and to understand user behaviour. The data obtained from Google Analytics helps us to improve the website effectively.",
                col5: 'Alphabet Inc.'
              }, {
                col1: '^_gat_gtag_UA',
                col2: '24usoftware.com',
                col3: '1 minute',
                col4: "The cookie is part of Google Analytics, which we use to anonymously measure statistics and to understand user behaviour. The data obtained from Google Analytics helps us to improve the website effectively.",
                col5: 'Alphabet Inc.',
                is_regex: true
              }]
            }, {
              title: 'Marketing cookies',
              description: "This group of cookies is used to show you ads of topics that you are interested in. It also lets us monitor our marketing activities, it helps to measure the performance of our ads.",
              toggle: {
                value: 'marketing',
                enabled: false,
                readonly: false
              },
              cookie_table: [
              // list of all expected cookies
              {
                col1: 'affiliate',
                // match all cookies starting with "_ga"
                col2: '24usoftware.com',
                col3: '24 hours',
                col4: "Cookie is part of our affiliate tracking. It is used to evaluate commission claims to our partners.",
                col5: '24U s.r.o.'
              }, {
                col1: 'affiliateid',
                // match all cookies starting with "_ga"
                col2: '24usoftware.com',
                col3: '24 hours',
                col4: "Cookie is part of our affiliate tracking. It is used to evaluate commission claims to our partners.",
                col5: '24U s.r.o.'
              }]
            }]
          }
        }
      };
      return translates;
    }
  }]);
  return CookieConsentComponent;
}();